import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=54fc22b5&scoped=true&"
import script from "./OrderList.vue?vue&type=script&lang=js&"
export * from "./OrderList.vue?vue&type=script&lang=js&"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=54fc22b5&scoped=true&lang=css&"
import style1 from "styles/components/queryHeader.css?vue&type=style&index=1&id=54fc22b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fc22b5",
  null
  
)

export default component.exports